import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';

import AppBundleContext from "./AppBundleContext";
import App from './App';
import { BundleContextProvider } from "./BundleProvider";
import configureLogging from './configureLogging';
import createStore from './createStore';
import * as AppActions from './actions/app';

import './styles/index.scss';

if (process.env.NODE_ENV === 'development') {
  const a11y = require('react-a11y').default;
  a11y(React, ReactDOM, {
    rules: {
      // 'aria-role': 'warn',
      // 'aria-unsupported-elements': 'warn',
      // 'click-events-have-key-events': 'warn',
      // 'hidden-uses-tabindex': 'warn',
      // 'img-redundant-alt': 'warn',
      // 'img-uses-alt': 'warn',
      // 'interactive-supports-focus': 'warn',
      // 'label-has-for': 'warn',
      // 'mouse-events-have-key-events': 'warn',
      // 'no-access-key': 'warn',
      // 'no-hash-ref': 'warn',
      // 'no-onchange': 'warn',
      // 'onclick-uses-role': 'warn',
      // 'tabindex-no-positive': 'warn',
      // 'tabindex-uses-button': 'warn',
    },
  });

  const axe = require('react-axe');
  axe(React, ReactDOM, 1000);
}

function selectLanguage() {
  if (process.env.APP_LANGUAGE === "en") {
    return require("./resources/en/bundle").default;
  }
  else if (process.env.APP_LANGUAGE === "es") {
    return require("./resources/es/bundle").default;
  }
}

configureLogging();
const appBundle = selectLanguage();

// wait for appBundle to be prepared before loading rest of app
appBundle.prepare().then(function() {
// prepare the store
  const store = createStore();

  // dispatch the load action
  store.dispatch(AppActions.load());
  document.getElementById('splash-screen').style.display = 'none';

  ReactDOM.render(
    <BundleContextProvider context={AppBundleContext}>
      <Provider store={store}>
        <HashRouter basename="/" >
          <App />
        </HashRouter>
      </Provider>,
    </BundleContextProvider>,
    document.getElementById('root'),
  );
});



// WEBPACK FOOTER //
// ./src/index.js